module.exports = __webpack_public_path__ + "static/media/icon-booth-rev-food.046d919d.svg";